module.exports = __webpack_public_path__ + "static/media/banner.d410b6f7.jpg";